module.exports = __webpack_public_path__ + "dingbeauty-landing/img/plan01@2.aa68da86.jpg";